import { CloseOutlined } from '@ant-design/icons';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Popper, ThemeProvider } from "@mui/material";
import { Button, Col, Divider, Progress, Row, Spin } from 'antd';
import { error_manager } from 'helper/error_manager';
import React, { Component } from 'react';
import { connect } from "react-redux";
import {receivedDeviceStatus, watchPollStatus} from 'redux_actions/device_status.action';
import { startLiveView, stopLiveView, watchPollLiveView } from 'redux_actions/liveview.action';
import { cancelScanning } from 'redux_actions/preview_status.action';
import { getSlideStatus } from 'redux_actions/slides.action';
import {getStateAwareUrl, isNull, isSuperuser, openEndPoint, slideStatusCategory} from 'utils/utils';
import "../../../asset/style/scanner/scanner.css";
import '../../../asset/style/workflow/scan-progress.css';
import { get_response } from "../../../helper/request";
import { sagaMiddleware } from "../../../helper/store";
import { ScanningStatus } from "../../../redux_constants/scan.constant";
import {
	antdSpinLoaderSmallIcon,
	cassetteType,
	deviceType,
	scanWorkflowLoadingMessages,
	slideStatusEnum,
	slideType,
	specimenType
} from "../../../utils/const";
import { morphleTheme1 } from "../../gammaviewer/themes";
import { getBarcodeCrop, getRotatedThumbnail } from '../preview_utils';
import {DeviceAlertConstant as DeviceConstants} from "../../../redux_constants/device.constant";
import {updateIsScanningStarted} from "../../../redux_actions/scanWorkflow.action";

class ScanProgress extends Component {
	constructor(props) {
		super(props);

		let cassetteSizeArray = [];

		for (let i = 0; i < this.props.deviceProperties.cassetteSize; i++) {
			cassetteSizeArray.push(i);
		}

		this.state = {
			liveView: "",
			debugVisible: false,
			slotIndexes: this.props.deviceProperties.deviceType === deviceType.MORPHOLENS_1 ? [0] : cassetteSizeArray,
			stitcher_percent: -1,
			date: (new Date()).getTime(),
			popperNotification: false,
			crashes: 0,
		}
		this.props.dispatch(receivedDeviceStatus(DeviceConstants.RECEIVED_DEVICE_STATUS, {data: null}, this.props.device_id));
		this.stitchingPoll = null

		this.pollerStatus = null
		this.pollerLiveView = null
		this.is_superuser = isSuperuser()
	}

	onCancelScanning = () => {
		this.props.dispatch(cancelScanning(this.props.device_id, this.props.loaderPresent));
	}

	onBackToControlPanel = () => {
		window.location.pathname = getStateAwareUrl('/scanners/' + this.props.device_id + '/');
	}

	getTiltNotificationContent = (currCrash) => <ThemeProvider theme={morphleTheme1}>
		<Popper open={this.state.popperNotification}
				placement='bottom-end'
				sx={{
					position: 'fixed', bottom: 15, right: 15, top: 'unset !important', left: 'unset !important',
					overflow: 'auto', padding: 1, border: 1, borderColor: 'orange', bgcolor: 'rgba(245,191,66,0.4)'
				}}>
			<Row style={{height: "130px", width: "375px"}}>
				<Col className='full-width' style={{height: '35%'}}>
					<Col span={2} offset={1} className={'full-height'}><WarningAmberIcon/></Col>
					<Col span={19} className={'full-height'}>
						{currCrash} {currCrash > 1 ? "slides have" : "slide has"} improper clamping.
						<br/><br/>
					</Col>
					<Col span={2}>
						<CloseOutlined style={{color: "red"}} onClick={() => this.onUserReclampSlide(true, false)}/>
					</Col>
				</Col>
				<Col className='full-width' style={{height: '65%'}}>
					<Col span={11}>
						<Row className='center'>
							<Button color="secondary" size="small"
									style={{height: 'auto', padding: '10px', width: '150px'}}
									onClick={() => this.onUserReclampSlide(false, false)}>
								{this.props.deviceProperties.deviceType === deviceType.MORPHOLENS_1 ?
									<span>Reclamp in <br/> same slot for <br/> time guarantee</span> :
									<span>Reclamp in <br/> a different slot for <br/> time guarantee</span> }
							</Button>
						</Row>
					</Col>
					<Col span={2} className={"full-height center"}>
						<Divider type="vertical" className={"full-height center"}
								 style={{backgroundColor: "orange"}}></Divider>
					</Col>
					<Col span={11}>
						<Row className='center'>
							<Button color="secondary" size="small"
									style={{height: 'auto', padding: '10px', width: '165px'}}
									onClick={() => this.onUserReclampSlide(true, true)}>
								Fallback to <br/> Slower Scanning <br/> with quality guarantee
							</Button>
						</Row>
					</Col>
				</Col>
			</Row>
		</Popper>
	</ThemeProvider>

	onUserReclampSlide = (rescan_slide, safe_rescan) => {
		let url = `/server/devices/${this.props.device_id}/user_interaction_rescan/?rescan=${rescan_slide}&safe_rescan=${safe_rescan}`;
		get_response(url).then(res => {
			this.setState({popperNotification: false})
			if(!(rescan_slide && safe_rescan)) {
				openEndPoint('/scanners/' + this.props.device_id, false, true);
			}
		}).catch(err => {
			this.setState({popperNotification: false})
			error_manager("Failed to update Rescan Setting", err);
		})
	}

	handleTiltNotification = (currCassetteStats, userInteractionDone) => {
		if(userInteractionDone && this.state.popperNotification) {
			this.setState({popperNotification: false});
			return;
		}

		let currCrash = 0;
		if (currCassetteStats) {
			Object.keys(currCassetteStats).map(slot => {
				let slotData = currCassetteStats[slot];
				if (slotData?.scanStatus === ScanningStatus.SCAN_CRASHED_WILL_RESCAN) {
					currCrash += 1;
				}
			})
		}
		if (!userInteractionDone && currCrash !== this.state.crashes) {
			this.setState({
				popperNotification: true,
				crashes: currCrash,
			})
		}
	}

	componentDidMount() {
		this.pollerStatus = sagaMiddleware.run(watchPollStatus, this.props.dispatch, this.props.device_id);
		this.pollerLiveView = sagaMiddleware.run(watchPollLiveView, "1");
		this.stitchingPoll = setInterval(this.slideRunner, 500);
		let cassetteSizeArray = [];
		let cassetteSize = this.props.scannerProperties.cassetteSize;
		if (this.props.cassetteType === cassetteType.TWO_2_BY_3_SLIDES) {
			cassetteSize = this.props.scannerProperties.cassetteSize2by3;
		}
		for (let i = 0; i < cassetteSize; i++) {
			cassetteSizeArray.push(i);
		}

		// update cassette type and slot size
		this.setState({
			slotIndexes: cassetteSizeArray
		});
	}

	componentDidUpdate = (prevProps) => {
        if (prevProps.cassetteType !== this.props.cassetteType) {
            let cassetteSizeArray = [];
            let cassetteSize = this.props.scannerProperties.cassetteSize;
            if (this.props.cassetteType === cassetteType.TWO_2_BY_3_SLIDES) {
                cassetteSize = this.props.scannerProperties.cassetteSize2by3;
            }
            for (let i = 0; i < cassetteSize; i++) {
                cassetteSizeArray.push(i);
            }

            // update cassette type and slot size
            this.setState({
                slotIndexes: cassetteSizeArray
            });
        }
		let scannerStatus = (((this.props.device || {}).scanner_health || {}).scanner_response || {});
		if (scannerStatus.erroredOut && !scannerStatus.scanning) {
			window.location.pathname = getStateAwareUrl('/scanners/' + this.props.device_id + '/');
		}

		let currCassetteStat = scannerStatus?.currentCassetteStats
		this.handleTiltNotification(currCassetteStat, scannerStatus?.userInteractionForRescan);

		let prevScanPreviewStatus = (((prevProps.device || {}).scanner_health || {}).scanner_response || {})?.scanPreviewStatus;
		let scanPreviewStatus = (((this.props.device || {}).scanner_health || {}).scanner_response || {})?.scanPreviewStatus;

		Object.keys(this.state.slotIndexes).map((index) => {
			if(((scanPreviewStatus || {})[index] || {})['previewStage'] === "CONFIRMED" &&
				((prevScanPreviewStatus || {})[index] || {})['previewStage'] !== ((scanPreviewStatus || {})[index] || {})['previewStage']) {
				this.setState({date: (new Date()).getTime()});
			}
		})

	}

	componentWillUnmount = () => {
		clearInterval(this.stitchingPoll);
		this.stitchingPoll = null;
		this.props.dispatch(stopLiveView());

		this.pollerStatus.cancel()
		this.pollerLiveView.cancel()
	}

	slideRunner = () => {
		let scansCompleted = [];
		let scanStatisticsPerSlot = (((((this.props || {}).device || {}).scanner_health || {}).scanner_response || {}).currentCassetteStats || {});
		Object.keys(scanStatisticsPerSlot).forEach(function (key) {
			let scanStats = scanStatisticsPerSlot[key];
			if (scanStats.scanCompleted) {
				scansCompleted.push({
					slot: key,
					name: scanStats.scanName,
					morphleID: scanStats.morphleID
				});
			}
		});
		if (scansCompleted.length !== 0) {
			scansCompleted.map((scan) =>
				this.props.dispatch(getSlideStatus(scan.morphleID, scan.slot)));
		}
	}

	toggleLiveView = () => {

		if (this.state.debugVisible) {
			this.props.dispatch(stopLiveView());
		} else {
			this.props.dispatch(startLiveView());
		}

		this.setState({
			debugVisible: !this.state.debugVisible,
		})
	}

	render() {
		if(isNull(this.pollerStatus) || isNull(((this.props.device || {}).scanner_health || {})?.scanner_response)) {
			return null;
		}

		let isHemo = false;
		if (this.props.deviceProperties.deviceType.includes("HEMOLENS")) {
			isHemo = true;
		}
		let scanStatisticsPerSlot = ((((this.props.device || {}).scanner_health || {}).scanner_response || {}).currentCassetteStats || {});

		let yetToScan = [];
		let scansCompleted = [];
		let currentScanProgress = 0;
		let currentScanElapsedTime = 0;
		let yetToScanComp = "";
		let scansCompletedComp = [];
		let scannerMessage = "Scanning";
		let currentScanSlot = null;
		let PERCENT_LIMIT = 85;
		let otherScansInfo = null;
		Object.keys(scanStatisticsPerSlot).forEach(function (key) {
			let scanStats = scanStatisticsPerSlot[key];
			if ((scanStats || {}).specimenType === specimenType.BM || ((scanStats || {}).specimenType === "BLOOD" && isHemo)) {
				PERCENT_LIMIT = 95;
			}
			if (scanStats.scanCompleted) {
				scansCompleted.push({
					slot: key,
					name: scanStats.scanName,
					morphleID: scanStats.morphleID
				});
			} else if (scanStats.yetToStart) {
				yetToScan.push({
					slot: key,
					name: scanStats.scanName,
					morphleID: scanStats.morphleID
				});
			} else {
				currentScanProgress = Math.min(PERCENT_LIMIT, scanStats.percentDone).toFixed(2);
				currentScanElapsedTime = scanStats.timeTillNow;
				currentScanSlot = key;
			}
		});

		for (let i = 0; i < yetToScan.length - 1; i++) {
			yetToScanComp += "Slot " + (parseInt(yetToScan[i].slot) + 1) + ", "
		}
		if (yetToScan.length > 0) {
			yetToScanComp += "Slot " + (parseInt(yetToScan[yetToScan.length - 1].slot) + 1);
		}

		for (let i = 0; i < scansCompleted.length - 1; i++) {
			scansCompletedComp.push(
				<a style={{padding: 10}} href={getStateAwareUrl('') + "/server/v4/tissue/" + scansCompleted[i].morphleID + `/?url_prefix=${getStateAwareUrl('')}`}>
					{scansCompleted[i].name + " "}
				</a>
			);
		}
		if (scansCompleted.length > 0) {
			scansCompletedComp.push(
				<a style={{padding: 10}}
				   href={getStateAwareUrl('') + "/server/v4/tissue/" + scansCompleted[scansCompleted.length - 1].morphleID + `/?url_prefix=${getStateAwareUrl('')}`}>
					{scansCompleted[scansCompleted.length - 1].name + " "}
				</a>
			);
		}

		if (currentScanElapsedTime === 0) {
			scannerMessage = "Setting Up"
		} else if (currentScanProgress >= PERCENT_LIMIT) {
			scannerMessage = "Almost Done"
		}

		let currentScanHeader = null;

		if (scansCompleted.length !== 0 || yetToScan.length !== 0) {
			otherScansInfo = [
				<Divider key={0} style={{color: "#535c68", padding: 10, paddingTop: 40}}
						 className="arial-font">{yetToScan.length} Queued for Scanning</Divider>,
				<Row key={1} className="arial-font" style={{fontSize: 15}}>{yetToScanComp}</Row>,
				<Divider key={2} style={{color: "#535c68", paddingTop: 40}}
						 className="arial-font">{scansCompleted.length} Scans Completed</Divider>,
				<Row key={3} className="arial-font" style={{fontSize: 16}}>
					{scansCompletedComp}
				</Row>
			]
			currentScanHeader = "Scanning Slot : " + (parseInt(currentScanSlot) + 1);
		}

		let completedScans = {}
        let SlideType = this.props.cassetteType === cassetteType.SIX_1_BY_3_SLIDES ? slideType.SLIDE_1_BY_3_INCH : slideType.SLIDE_2_BY_3_INCH;
		for (let id in scansCompleted) {
			completedScans[scansCompleted[id].slot] = scansCompleted[id]
		}

		let slides = Object.keys(this.state.slotIndexes).map((index) => {
			let endText = scanWorkflowLoadingMessages.STITCHING
			if ((scanStatisticsPerSlot[index] || {}).specimenType === specimenType.BM || ((scanStatisticsPerSlot[index] || {}).specimenType === "BLOOD" && isHemo)) {
				endText = scanWorkflowLoadingMessages.RUNNING_AI;
			}
			return <Col span={4} key={index} className="centered" style={{marginTop: 50}}>
				<a href={completedScans.hasOwnProperty(index) &&
				slideStatusCategory(this.props.slideStatus[index]?.status) === slideStatusEnum.VIEWER_READY ?
					(this.props.slideStatus[index].specimen_type === "blood" ||
						this.props.slideStatus[index].specimen_type === "bone_marrow") ?
						getStateAwareUrl("/blood/" + ((this.props.slideStatus || {})[index] || {}).id) :
						getStateAwareUrl("/gamma/" + ((this.props.slideStatus || {})[index] || {}).id) : "#"}>
					<div className={ SlideType === slideType.SLIDE_1_BY_3_INCH ? "centered carousel-item" : "centered carousel-item-2by3"}
					     style={(index in scanStatisticsPerSlot && ((scanStatisticsPerSlot[index] || {}).scanStatus !== ScanningStatus.ALL_GOOD)) ?
						     {
							     height: '486px',
							     backgroundImage: 'url(' + getRotatedThumbnail(parseInt(index), 0, 0) + ')',
							     backgroundSize: 'auto 350px',
							     backgroundColor: 'rgb(255 255 255 / 50%)',
							     backgroundRepeat: 'no-repeat',
							     backgroundPositionY: 'top',
								 borderColor: "rgb(255 0 0)"
							 }
							 : (index in scanStatisticsPerSlot ?
								 (currentScanSlot === index ? (SlideType === slideType.SLIDE_1_BY_3_INCH ?
                                    {height: '486px', backgroundImage: 'url(' + getRotatedThumbnail(parseInt(index), 0, 0) + '?' + this.state.date + ')',
                                    backgroundSize: 'auto 350px', backgroundColor: 'rgb(255 255 255 / 40%)', animation: 'shadow-pulse4 1.5s infinite', backgroundRepeat: 'no-repeat',
                                    backgroundPositionY: 'top'} : (
                                        SlideType === slideType.SLIDE_2_BY_3_INCH ? {height: '486px', backgroundImage: 'url(' + getRotatedThumbnail(parseInt(index), 0, 0) + '?' + this.state.date + ')',
                                        backgroundSize: 'auto 350px', backgroundColor: 'rgb(255 255 255 / 40%)', animation: 'shadow-pulse4 1.5s infinite', backgroundRepeat: 'no-repeat',
                                        backgroundPositionY: 'top'} 
                                        : {height: '587px', backgroundImage: 'url(' + getRotatedThumbnail(parseInt(index), 0, 0) + '?' + this.state.date + ')',
                                        backgroundSize: 'auto 450px', backgroundColor: 'rgb(255 255 255 / 40%)', animation: 'shadow-pulse4 1.5s infinite', backgroundRepeat: 'no-repeat',
                                        backgroundPositionY: 'top'}
                                    ))
                                     : (SlideType === slideType.SLIDE_1_BY_3_INCH ? {height: '486px', backgroundImage: 'url(' + getRotatedThumbnail(parseInt(index), 0, 0) + '?' + this.state.date + ')',
                                     backgroundSize: 'auto 350px', backgroundColor: 'rgb(255 255 255 / 50%)', backgroundRepeat: 'no-repeat', backgroundPositionY: 'top'} 
                                     : (SlideType === slideType.SLIDE_2_BY_3_INCH ? {height: '486px', backgroundImage: 'url(' + getRotatedThumbnail(parseInt(index), 0, 0) + '?' + this.state.date + ')',
                                     backgroundSize: 'auto 350px', backgroundColor: 'rgb(255 255 255 / 50%)', backgroundRepeat: 'no-repeat', backgroundPositionY: 'top'} 
                                        : {height: '587px', backgroundImage: 'url(' + getRotatedThumbnail(parseInt(index), 0, 0) + '?' + this.state.date + ')',
                                        backgroundSize: 'auto 450px', backgroundColor: 'rgb(255 255 255 / 50%)', backgroundRepeat: 'no-repeat', backgroundPositionY: 'top'}))
                                ) : {backgroundColor: 'rgb(230 230 230 / 80%)', opacity: '0.3'})
						 }>

						{((index in scanStatisticsPerSlot) && ((scanStatisticsPerSlot[index] || {}).scanStatus !== ScanningStatus.ALL_GOOD)) ?
						((scanStatisticsPerSlot[index] || {}).scanStatus !== ScanningStatus.SCAN_CRASHED_NOT_ENOUGH_AREA) ?
							<div style={{position: 'absolute'}}>
								<span className="centered" style={{color: "black"}}>{"Scan postponed"}</span>
								<span className="centered" style={{color: "black"}}>{"due to"}</span>
								<span className="centered" style={{color: "black"}}>{"bad prognosis"}</span>
								<span className="centered" style={{color: "black"}}>{"of scan time"}</span>
								<br/>
								<span className="centered" style={{color: "black"}}>{"Re-clamp slide on"}</span>
								<span className="centered" style={{color: "black"}}>
									{this.props.deviceProperties.deviceType === deviceType.MORPHOLENS_1 ? "same slot" : "different slot"}
								</span>
								<span className="centered" style={{color: "black"}}>{"for faster scan"}</span>
							</div>
							: 
							<div style={{position: 'absolute'}}>
								<span className="centered" style={{color: "black"}}>{"Scan cancelled"}</span>
								<span className="centered" style={{color: "black"}}>{"due to"}</span>
								<span className="centered" style={{color: "black"}}>{"inability to find"}</span>
								<span className="centered" style={{color: "black"}}>{"minimum scan area"}</span>
								<br/>
								<span className="centered" style={{color: "black"}}>{"Re-scan slide with"}</span>
								<span className="centered" style={{color: "black"}}>{"correct specimen type"}</span>
								<span className="centered" style={{color: "black"}}>{"or select tissue area"}</span>
							</div>
							: null
							}

						{(index in scanStatisticsPerSlot
							|| (currentScanSlot === index && (currentScanProgress < 100))
							|| (completedScans.hasOwnProperty(index)))
							?
							<div className="centered" style={
								currentScanSlot === null ?
								{
									border: '0px',
									borderLeft: '3px solid #111111',
									backgroundColor: 'gray',
									backgroundImage: 'url(' + getBarcodeCrop(parseInt(index), 0, 0) + "?" + this.state.date + ')',
									backgroundSize: 'contain',
									backgroundRepeat: 'no-repeat', transform: 'rotate(90deg)', position: 'relative',
									right: '0px', bottom: '-175px', height: '147px', width: '133px'
								} :
								((SlideType === slideType.SLIDE_1_BY_3_INCH) || (SlideType === slideType.SLIDE_2_BY_3_INCH)) ?
                                    {
                                    border: '0px',
                                    borderLeft: '3px solid #111111',
                                    backgroundColor: 'gray',
                                    backgroundImage: 'url(' + getBarcodeCrop(parseInt(index), 0, 0) + "?" + this.state.date + ')',
                                    backgroundSize: 'contain',
                                    backgroundRepeat: 'no-repeat', transform: 'rotate(90deg)', position: 'relative',
                                    right: '0px', bottom: '-175px', height: '147px', width: '133px'}
                                : {
                                    border: '0px',
                                    borderLeft: '3px solid #111111',
                                    backgroundColor: 'gray',
                                    backgroundImage: 'url(' + getBarcodeCrop(parseInt(index), 0, 0) + "?" + this.state.date + ')',
                                    backgroundSize: 'contain',
                                    backgroundRepeat: 'no-repeat', transform: 'rotate(90deg)', position: 'relative',
                                    right: '0px', bottom: '-225px', height: '147px', width: '133px'}}></div>
                                : null }

						{((index in scanStatisticsPerSlot) && ((scanStatisticsPerSlot[index] || {}).scanStatus !== ScanningStatus.ALL_GOOD)) ?
							null :
							(currentScanSlot === index && currentScanProgress < 100
								? <div style={{position: 'absolute'}}>
									<Progress className="centered" type="circle"
											  percent={parseFloat(currentScanProgress)} width={80}/>
									<h4 className="centered">Scanning</h4>
								</div>
								: null)
						}

						{((index in scanStatisticsPerSlot) && ((scanStatisticsPerSlot[index] || {}).scanStatus !== ScanningStatus.ALL_GOOD)) ?
							null :
							(completedScans.hasOwnProperty(index)
								? <div style={{position: 'absolute'}}>
									<Progress type="circle" className="centered"
											  percent={slideStatusCategory(this.props.slideStatus[index]?.status) === slideStatusEnum.VIEWER_READY
												  ? 100 : Number(this.props.slideStatus[index]?.stitcher_percent || 0).toFixed(2)}
											  width={80}/>
									<h4 className="centered">
										{slideStatusCategory(this.props.slideStatus[index]?.status) === slideStatusEnum.VIEWER_READY ? "Click to View" : endText}
									</h4>
								</div>
								: null)
						}
					</div>
				</a>
			</Col>
		});

		let busyOrder = ((((this.props.device || {}).scanner_health || {}).scanner_response || {}).busyOrder || [])
		let scannerBusy = busyOrder.length !== 0;
		let busyDict = ((((this.props.device || {}).scanner_health || {}).scanner_response || {}).busyDict || {})
		let busyMessage = busyDict[busyOrder[0]]
		let isScanning = (((this.props.device || {}).scanner_health || {}).scanner_response || {}).scanning;

		return (
			<Spin indicator={antdSpinLoaderSmallIcon} style={{color: '#000'}} spinning={scannerBusy} tip={busyMessage}>
				<Row className='centered carousel'>
					{slides}
				</Row>
				<Row className="centered" style={{marginTop: 50}}>
					<Col>
						{this.is_superuser ?
							<Button onClick={this.toggleLiveView} style={{margin: '20px'}}>
								{this.state.debugVisible ? 'Close Debug' : 'View Debug'}
							</Button> : undefined
						}
					</Col>
					<Col>
						{isScanning ?
							<Button type="danger" ghost style={{margin: '20px'}}
									onClick={this.onCancelScanning}
									disabled={currentScanSlot === null}>
								Stop Scanning
							</Button>
							: <Button type="danger" ghost style={{margin: '20px'}}
									  onClick={this.onBackToControlPanel}>
								Back to Control Panel
							</Button>
						}
					</Col>
				</Row>
				<Row className="rounded-container"
					 style={this.state.debugVisible ? {display: 'block'} : {display: 'none'}}>
					<Col span={6} offset={3} className="slot-menu scan-progress-section">
						<Row><Divider style={{color: "#535c68"}}
									  className="arial-font">{currentScanHeader}</Divider></Row>
						<Row className="arial-font" style={{padding: 10, fontSize: 15}}>{scannerMessage}</Row>
						<Progress type="circle" percent={parseFloat(currentScanProgress)} width={80}/>
						{otherScansInfo}
						<Row className="start-scan-button-div">
							<Button type="danger" size={'large'} onClick={this.onCancelScanning}
									disabled={currentScanSlot === null}>Stop Scanning</Button>
						</Row>
						<Row><Divider style={{color: "#535c68"}} className="arial-font"></Divider></Row>
					</Col>
					<Col span={12} offset={3}>
						<Row><img alt="Live" className="live-view"
								  src={"data:image/png;base64," + this.props.liveView.data}/></Row>
					</Col>
				</Row>
				{this.getTiltNotificationContent(this.state.crashes)}
			</Spin>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		device: state.deviceStatusReducer[ownProps.device_id],
		liveView: state.liveViewReducer,
		previews: state.previewStatusReducer,
		slideStatus: state.slidesReducer,
		notifications: state.gammaStateReducer.notifications,
		deviceProperties: state.deviceAlert.deviceProperties,
		isScanningStarted: state.scanWorkflowReducer.isScanningStarted,
	};
};

export default connect(mapStateToProps)(ScanProgress);
